import { jwtDecode } from 'jwt-decode'

import { useLocalStorage } from '../useLocalStorage'

export function useLocalUser() {
  const [token] = useLocalStorage('token')

  if (!token) {
    return { email: null, userId: null }
  }

  const { userId, email } = jwtDecode<{
    email: string
    userId: string
  }>(token)

  return {
    email,
    userId,
  }
}
